import React, { useState } from 'react';

export const PasswordProtectedVideo = ({
  src,
  title = 'Product Demo',
  description,
  correctPassword,
}) => {
  const [isUnlocked, setIsUnlocked] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === correctPassword) {
      setIsUnlocked(true);
      setError('');
    } else {
      setError('Incorrect password');
      setPassword('');
    }
  };

  return (
    <div style={styles.container}>
      {description && (
        <div style={styles.description}>
          {description.split('\n\n').map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}
        </div>
      )}

      {!isUnlocked ? (
        <div style={styles.passwordModal}>
          <div style={styles.modalContent}>
            <div style={styles.lockIcon}>🔒</div>
            <h3 style={styles.modalTitle}>Video Password Protected</h3>
            <p style={styles.modalText}>
              Enter the password to watch the demo
            </p>
            <form onSubmit={handleSubmit} style={styles.form}>
              <input
                type="password"
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={styles.input}
                autoFocus
              />
              {error && <p style={styles.error}>{error}</p>}
              <button type="submit" style={styles.button}>
                Watch Video
              </button>
            </form>
          </div>
        </div>
      ) : (
        <iframe
          allowFullScreen
          mozallowfullscreen="true"
          webkitallowfullscreen="true"
          allow="autoplay; fullscreen; picture-in-picture"
          src={src}
          title={title}
          width="100%"
          style={styles.iframe}
        />
      )}
    </div>
  );
};

const styles = {
  container: {
    width: '100%',
    maxWidth: '1000px',
    margin: '0 auto',
    padding: '20px',
  },
  description: {
    marginBottom: '24px',
    fontSize: 'clamp(14px, 2vw, 16px)',
    color: '#666',
    lineHeight: '1.6',
  },
  passwordModal: {
    width: '100%',
    aspectRatio: '1728 / 974',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f5f5f5',
    borderRadius: '8px',
    border: '1px solid #e0e0e0',
  },
  modalContent: {
    textAlign: 'center',
    padding: '40px',
    maxWidth: '400px',
  },
  lockIcon: {
    fontSize: '48px',
    marginBottom: '16px',
  },
  modalTitle: {
    fontSize: '24px',
    fontWeight: '600',
    margin: '0 0 16px 0',
    color: '#111111',
    fontFamily: '"Source Serif Pro", Georgia, serif',
  },
  modalText: {
    fontSize: '15px',
    color: '#4A4A4A',
    margin: '0 0 32px 0',
    lineHeight: '1.6',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  input: {
    padding: '12px 16px',
    fontSize: '14px',
    border: '1px solid #ddd',
    borderRadius: '6px',
    fontFamily: 'inherit',
    boxSizing: 'border-box',
  },
  button: {
    padding: '14px 32px',
    fontSize: '14px',
    fontWeight: '600',
    color: '#fff',
    backgroundColor: '#385cbc',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
  },
  buttonHover: {
    backgroundColor: '#2a45a0',
  },
  error: {
    fontSize: '12px',
    color: '#d32f2f',
    margin: '0',
  },
  iframe: {
    width: '100%',
    aspectRatio: '1728 / 974',
    height: 'auto',
    maxWidth: 'calc(95vh * 1728 / 974)',
    margin: '0 auto',
    display: 'block',
    border: 0,
    borderRadius: '8px',
  },
};
